const findEdgesForPaths = (resultPaths, edges) => {
    return resultPaths.map(({ pathNodes, startNode, pathType }) => {
        const pathEdges = edges.filter(edge =>
            pathNodes.includes(edge.source) && pathNodes.includes(edge.target)
        );

        return {
            pathNodes,
            startNode,
            pathType,
            edges: pathEdges
        };
    });
};

export default findEdgesForPaths